import { useContext } from 'react';
import { ThemeContext } from "../ThemeContext";
export var useTheme = function useTheme() {
  return useContext(ThemeContext);
};